import React from "react";
import Modal from "react-bootstrap/Modal";
import { gql } from "@apollo/client";

import closeIcon from "../../../assets/close.svg";
import "./AddNewUserModal.scss";
import { apolloClient } from "../../../index";
import { notify } from "../../Notify/Notify";

export const isValidEmail = (email) => {
  //eslint-disable-next-line
  return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};

export const isValidMobileNumberCheck = (mobile) => {
  //eslint-disable-next-line
  return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
    mobile
  );
};

export default class AddNewUserModal extends React.Component {
  state = {
    email: "",
    role: 0,
    // roles: ["Select one", "Admin", "Owner", "User", "Guest"],
    roles: [
      { id: 0, value: "Select One" },
      { id: 1, value: "IT Admin" },
      { id: 2, value: "Admin" },
      { id: 3, value: "Manager" },
      { id: 4, value: "User" },
      { id: 5, value: "Guest" },
    ],
    editMode: false,
  };

  hasValidValues = () => {
    return (
      this.state.email.trim().length > 0 &&
      isValidEmail(this.state.email.trim()) &&
      this.state.role !== this.state.roles[0].id
    );
  };

  onChangeOption = (e) => {
    this.setState({ role: Number(e.target.value) });
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (!this.props.editMode) {
        this.setState({
          email: "",
          role: 0,
          editMode: false,
        });
      } else {
        this.setState({
          ...this.props.editMode,
          role: this.state.roles.filter(
            (role) => role.value === this.props.editMode.role
          )[0].id,
          editMode: true,
        });
      }
    }
  }

  render() {
    const sendSingleUserInvite = (e) => {
      e.preventDefault();
      this.props.handleClose();

      const variables = {
        email: this.state.email,
        roleId: this.state.role,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation InviteSingleUser($email: String!, $roleId: Int!) {
              sendSingleUserInvitation(
                inviteReceiverEmail: $email
                roleId: $roleId
              ) {
                token
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.sendSingleUserInvitation.token) {
            // Add toaster on successfully invitation
            const title = "Success";
            const detail = "Invitation sent successfully";
            const type = "success";
            notify(title, detail, type);
          }
        })
        .catch((e) => {
          //notify for an error
          const title = "Error";
          const detail = e.message;
          const type = "error";
          notify(title, detail, type);
        });
    };

    const editUserRole = (e) => {
      e.preventDefault();
      this.props.handleClose();
      this.props.updateUserRole(this.props.editMode.id, this.state.role);
      const variables = {
        userId: this.props.editMode.id,
        roleId: this.state.role,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation EditUserRole($userId: Int!, $roleId: Int!) {
              editUserRole(userId: $userId, roleId: $roleId) {
                success
                user {
                  id
                  profile {
                    role {
                      id
                    }
                  }
                }
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.editUserRole.success) {
            const title = "Success";
            const detail = "User details updated successfully.";
            const type = "success";
            notify(title, detail, type);
          }
        })
        .catch((e) => {
          const title = "Success";
          const detail = e.message;
          const type = "success";
          notify(title, detail, type);
        });
    };

    return (
      <Modal
        className="new-user-modal"
        size="sm"
        centered
        show={this.props.showModal}
        onHide={this.props.handleClose}
      >
        <div className="new-user-modal-content">
          <div className="header">
            <h3 className="title is-size-h3 bold">
              {this.state.editMode ? "Edit User" : "Invite Single User"}
            </h3>
            <img
              className="close"
              src={closeIcon}
              alt="close"
              onClick={this.props.handleClose}
            />
          </div>

          <div className="body">
            <div className="form-groups">
              <div className="form-group">
                <label>
                  <strong>Email*</strong>
                </label>
                <input
                  type="email"
                  maxLength="50"
                  value={this.state.email}
                  readOnly={this.state.editMode}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  className={`form-control email ${
                    this.state.email && !isValidEmail(this.state.email)
                      ? "error-input"
                      : ""
                  }`}
                  placeholder="john.doe@email.com"
                />
                {this.state.email && !isValidEmail(this.state.email) ? (
                  <label className="error">
                    Please enter a valid email address eg: xyz@xyz.com
                  </label>
                ) : null}
              </div>

              <div className="form-group role-form-group">
                <label>
                  <strong>Role*</strong>
                </label>
                <select
                  name="role"
                  onChange={this.onChangeOption}
                  value={this.state.role}
                >
                  {this.state.roles.map((role) =>
                    parseInt(this.props.currentUserId) === 1 ? (
                      <option key={role.id} value={role.id}>
                        {role.value}
                      </option>
                    ) : role.value !== "IT Admin" && role.value !== "Admin" ? (
                      <option key={role.id} value={role.id}>
                        {role.value}
                      </option>
                    ) : null
                  )}
                </select>
              </div>
            </div>
          </div>

          <div className="footer">
            <button
              className="btn-tertiary cancel-button"
              onClick={this.props.handleClose}
            >
              Cancel
            </button>
            <button
              className="btn-primary create-button"
              disabled={!this.hasValidValues()}
              onClick={
                this.state.editMode ? editUserRole : sendSingleUserInvite
              }
            >
              {this.state.editMode ? "Update" : "Invite"}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
